<template>
  <div :class="$style.page">
    <!-- <div :class="$style.baseWrapper">
      <div :class="$style.base">
        <div :class="$style.baseInfo">
          <h1 :class="$style.baseTitle">成为全球卓越的<br>数字人才发展平台</h1>
          <div :class="$style.baseSubtitle">推动数字人才全面发展，助力数字中国早日实现</div>
        </div>
        <div :class="$style.gradual"></div>
      </div>
    </div> -->

    <div :class="$style.baseWrapper">
      <swiper :class="$style.picSwiper" :options="swiperOption" ref="swiper">
        <swiper-slide
          :class="$style.swiperSlide"
          :key="index"
          v-for="(item, index) in pictureList">
          <img :src="item">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div :class="$style.baseInfo">
        <h1 :class="$style.baseTitle">推动数字人才全面发展<br>助力数字中国早日实现</h1>
        <div :class="$style.baseSubtitle">成为全球卓越的数字人才发展平台</div>
      </div>
    </div>

    <div :class="$style.businessMapWrapper">
      <img :class="$style.businessMapImg" :src="businessMapImg">
    </div>

    <div :class="$style.moduleList">
      <div :class="$style.module" :key="index" v-for="(item, index) in productList">
        <img :class="$style.logo" :src="item.logo" :style="{height: `${item.logoHeight}px`}">
        <h2 :class="$style.title" v-html="item.titleHtml"></h2>
        <img :class="$style.introImg" :src="item.introImg" :style="{height: `${item.introImgHeight}px`}">
        <div :class="$style.intro">{{ item.intro1 }}</div>
        <div :class="[$style.intro, $style.intro2]">{{ item.intro2 }}</div>
        <div class="m-button-orange" @click="jump(item)">访问官网</div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import businessMapImg from '@/assets/img/home/business-map-h5.png'
import picture1 from '@/assets/img/home/picture/01.png'
import picture2 from '@/assets/img/home/picture/02.png'
import picture3 from '@/assets/img/home/picture/03.png'

import { getProductList } from '../data'

export default {
  name: 'coupon',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      businessMapImg,
      productList: getProductList(true),
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      pictureList: [
        picture1,
        picture2,
        picture3
      ]
    }
  },
  computed: {
  },
  created () {

  },
  destroyed () {
  },
  methods: {
    jump (item) {
      window.open(item.link)
    }
  }
}
</script>

<style lang="scss" module>
.baseWrapper {
  position: relative;

  .baseInfo {
    position: absolute;
    z-index: 9;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
    width: 270px;
  }

  .baseTitle {
    margin: 0;
    text-align: center;
    line-height: 36px;
    font-size: 27px;
    font-weight: 600;
    color: #fff;
  }

  .baseSubtitle {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 20px;
    text-align: center;
  }
}

.picSwiper {
  :global .swiper-pagination{
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: rgba(0,0,0,.5);
    }

    .swiper-pagination-bullet-active {
      background: #fff;
    }
  }
}

.businessMapWrapper {
  display: flex;
  justify-content: center;
}

.businessMapImg {
  width: 100%;
}

.module {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 30px;

  .title {
    margin-top: 16px;
    margin-bottom: 20px;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    color: #404040;
    line-height: 28px;
  }

  .introImg {
    margin-bottom: 24px;
  }

  .intro {
    line-height: 26px;
    font-size: 14px;
    font-weight: 300;
    color: #404040;
  }

  .intro2 {
    margin-top: 15px;
    margin-bottom: 30px;
  }

  &:nth-child(2n) {
    background: linear-gradient(3deg, #FFF9F0 0%, #FFF8EC 100%);
  }
}

</style>
